import React, { Fragment } from 'react';
import styled from 'styled-components';
import Skeleton from '../skeleton';
import LicenceGroup from './licenceGroup';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  padding-top: 20px;
`;

class LicenceSelectorScreenContent extends React.Component {
  render = () => {
    return (
      <ContentWrapper>
        {this.props.licencesLoading ? (<Skeleton nbCols={2} expand={true}></Skeleton>
        ) :
        <>
          {(this.props.licenceGroups.map((group, idx) => {
            return <Fragment key={idx}>
                <LicenceGroup
                  licenceGroup={group}
                  isSaving={this.props.isSaving}
                  onAddSoftwareLicencesRequested={this.props.onAddSoftwareLicencesRequested}
                  softwareLicences={this.props.softwareLicences}
                  configurationSaver={this.props.configurationSaver}
                  removeSoftwareLicence={this.props.removeSoftwareLicence}
                  setSoftwareLicenceQuantity={this.props.setSoftwareLicenceQuantity}
                  licenseLevel={this.props.licenseLevel}
                  licenseModel={this.props.licenseModel}
                />
            </Fragment>
          }))}
        </>
        }
      </ContentWrapper >
    );
  }
}

export default LicenceSelectorScreenContent;
